import { render } from "./TopBar.vue?vue&type=template&id=ad49d2c4&scoped=true"
const script = {}

import "./TopBar.vue?vue&type=style&index=0&id=ad49d2c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad49d2c4"]])

export default __exports__